import { gql } from 'graphql-tag'

/** CWA's terms acceptance. See `getConsumerCWA.ts` for why it stays narrow. */
export const AGREE_TO_TERMS_AND_CONDITIONS_CWA = gql`
  mutation agreeToTermsAndConditionsCWA {
    agreeToTermsAndConditions {
      agreedToTermsAndConditions
    }
  }
`
